import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAuthResponse } from '../../auth/models/login';
//import { CacheClearService } from './cache-clear.service';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  private router = inject(Router)
  //private cacheClearService = inject(CacheClearService);


  getToken(): string | null {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return token;
    } else {
      return null
    }
  }

  getRole(): string | null {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Role;
    }
    else return null;
  }

  saveToken(token: string, response: IAuthResponse) {
    sessionStorage['RTS_Token'] = token;
    sessionStorage['API_Token'] = JSON.stringify(response);
  }

  destroyToken() {
    sessionStorage.removeItem('RTS_Token');
    sessionStorage.removeItem('API_Token');
    sessionStorage.removeItem('Permission');
  }

  public urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: { break; }
      case 2: { output += '=='; break; }
      case 3: { output += '='; break; }
      default: {
        throw 'Illegal base64url string!';
      }
    }
    return this.b64DecodeUnicode(output);
  }


  private b64decode(str: string): string {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output: string = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 == 1) {
      throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }

    for (
      // initialize result and counters
      let bc: number = 0, bs: any, buffer: any, idx: number = 0;
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  }

  // https://developer.mozilla.org/en/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
  private b64DecodeUnicode(str: any) {
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  public decodeToken(token: string): any {
    let parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }

    let decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }

    return JSON.parse(decoded);
  }

  public getTokenExpirationDate(token: string): Date | null {
    let decoded: any;
    decoded = this.decodeToken(token);
    if (!decoded.hasOwnProperty('exp')) {
      return null;
    }

    let date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  public isTokenExpired(token: string, offsetSeconds?: number): boolean {
    // let date = this.getTokenExpirationDate(token);
    // offsetSeconds = offsetSeconds || 0;

    // if (date == null) {
    //   return false;
    // }

    // // Token expired?
    // return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
    return false;
  }

  checkToken(): boolean {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null) {
      return true;
    }
    return false
  }

  checkSessionTimeout(): boolean {
    const token = sessionStorage.getItem('RTS_Token');

    if (token != null && !this.isTokenExpired(token)) {
      return true;
    }
    else {
      return false
    }
  }

  getLoggedInUserId(): number | null {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return Number(this.decodeToken(token).UserId);
    }
    else {
      return null
    };
  }

  getLoggedInUserRole(): string | null {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Role;
    }
    else {
      return null
    };
  }

  getLoggedInUserPhone(): string | null {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Phone;
    }
    else {
      return null
    };
  }

  logout() {
    this.destroyToken();
    this.router.navigate(['/'])
  }

  getAPIToken(): string | null {
    const token = sessionStorage.getItem('API_Token');
    if (token == null) return null
    const jsonToken = JSON.parse(token);
    if (jsonToken != null && jsonToken.token && !this.isTokenExpired(jsonToken.token)) {
      return token;
    } else {
      return null
    }
  }

  isIndialogin(): boolean {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      const decoded = this.decodeToken(token);
      return decoded.IsLoggedinAsIndia === 'True';
    }
    return false;
  }

  getDepartmentName() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).DeaprtName;
    }
    else {
      return false
    };
  }
  getLoggedInUserName() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).UserName;
    }
    else {
      return false
    };
  }
  getLeadCount() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).LeadCount;
    }
    else {
      return false
    };
  }
  getManagerCount() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).ManagerCount;
    }
    else {
      return false
    };
  }
  getLoginUserContactEmail() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).ContactEmail;
    }
    else {
      return false
    };
  }
  getLoggedInUserFirstName() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).FirstName;
    }
    else {
      return false
    };
  }
  

  getLoggedInUserCountry() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Country;
    }
    else {
      return false
    };
  }

   getLoginUserContactPhone() {
    const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).ContactPhone;
    }
    else {
      return false
    };
  }

  getLoggedInUserLastName(){
     const token = sessionStorage.getItem('RTS_Token');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).LastName;
    }
    else {
      return false
    };
  }
  
}




